/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FadeInAnimation, LinkUnderlineAnimation } from '../shared';
import { useCitiesData } from '../../domain/city/city.domain';

const FeaturedCities = (props) => {

    const { cityName } = props;    

    const { data: fetchedCities } = useCitiesData();

    const cities = _.map(fetchedCities, (city) => city);    

    const renderCities = () => {
        return _.map(cities, (city, index) => {
            const name = _.get(city, 'name');
            const cityId = _.get(city, 'id');
            if (name !== cityName) {
                return (
                    <div className='play-page-featured-cities-link-container' key={index}>
                        <LinkUnderlineAnimation
                            large
                            id={`${name}_link`}
                            href={`/play/own-your-city/${name}/${cityId}`}
                        >
                            {name}
                        </LinkUnderlineAnimation>
                    </div>
                );
            }
            return null;
        });
    };

    return (
        <div className='container-root container-root-maxWidthLg'>
            <FadeInAnimation>
                <div className='play-page-featured-cities-city-container'>
                    <p className='play-page-featured-cities-text'>Other Featured Cities</p>
                    {renderCities()}
                </div>
            </FadeInAnimation>
        </div>
    );
};

export default FeaturedCities;

FeaturedCities.propTypes = {
    fetchedCities: PropTypes.object,
    cityName: PropTypes.string,
};
